<!-- display-desktop-01 preview — Google video partners in-stream, YouTube Video Ad -->
<app-desktop-frame>
  <!-- START: Publisher page -->
  <div class="ytv-gpd-page">
    <!-- The mock names the partner site rather than drawing one: the ad is the
         subject, and the placement runs on any of them. -->
    <div class="ytv-gpd-masthead d-flex align-items-center justify-content-center">
      - Website -
    </div>

    <div class="ytv-gpd-body d-flex flex-row">
      <!-- START: Player running the ad -->
      <div class="ytv-gpd-column d-flex flex-column">
        <div class="ytv-gpd-player">
          <img
            *ngIf="thumbnailUrl; else noCreative"
            class="ytv-gpd-creative"
            [src]="thumbnailUrl"
            alt=""
          />

          <ng-template #noCreative>
            <div class="ytv-gpd-creative creative-missing">
              <ng-container *ngIf="isResolving; else askForVideo">
                Reading video format&hellip;
              </ng-container>
              <ng-template #askForVideo>
                Add a video to see this preview
              </ng-template>
            </div>
          </ng-template>

          <!-- Ad chrome, only drawn over a creative — it is unreadable on the
               grey empty slot. -->
          <ng-container *ngIf="thumbnailUrl">
            <!-- The companion card: the only part of the player the author
                 writes. It is the CTA that carries the link, so the player
                 itself is not an anchor. -->
            <div class="ytv-gpd-card d-flex flex-row align-items-center">
              <img
                class="ytv-gpd-logo"
                src="assets/images/google-campaign-logos/collection/valamar-collection-512x512-color.png"
                alt=""
              />

              <div class="ytv-gpd-card-text d-flex flex-column">
                <span class="ytv-gpd-headline">{{ headline }}</span>
                <span class="ytv-gpd-url">{{ displayUrl }}</span>
              </div>

              <a
                [href]="data.url"
                target="_blank"
                rel="noopener noreferrer"
                class="ytv-gpd-cta"
                >{{ ctaText }}</a
              >
            </div>

            <span class="ytv-gpd-skip">Skip Ad <i class="bi bi-skip-end-fill"></i></span>
            <span class="ytv-gpd-countdown">00:16</span>
          </ng-container>
        </div>

        <!-- A yellow bar is what marks the player as running an ad. -->
        <div class="ytv-gpd-progress"><span class="ytv-gpd-progress-fill"></span></div>

        <div class="ytv-gpd-controls d-flex align-items-center">
          <i class="bi bi-pause-fill"></i>
        </div>
      </div>
      <!-- END: Player -->

      <!-- The publisher's article column beside the player, stubbed out -->
      <div class="ytv-gpd-rail d-flex flex-column">
        <span class="ytv-gpd-block placeholder"></span>
        <span
          *ngFor="let line of railLines; last as isLast"
          class="ytv-gpd-bar placeholder"
          [class.ytv-gpd-bar-short]="isLast"
        ></span>
      </div>
    </div>
  </div>
  <!-- END: Publisher page -->
</app-desktop-frame>
